export default __webpack_public_path__ + "img/dumcTuAm.839751bd.svg";